import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import "./index.css";
import { ToastContainer } from "./components/Toast";
import App from "./routes";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

// ------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <AuthProvider>
  <QueryClientProvider client={queryClient}>
    <>
      <App />
      <ToastContainer theme="dark" pauseOnHover newestOnTop pauseOnFocusLoss />
    </>
  </QueryClientProvider>
  // </AuthProvider>
);







